module.exports = __webpack_public_path__ + "img/ico_menual04_off.f067abc6.svg";